<template>
  <div>
    <b-card
      ><div class="organism-veeam_header card-padding">
        <span class="header__label">Veeam Management</span>
        <atom-button
          v-if="hasUpdatePermission"
          buttonId="add-new-veeam"
          class="mt-1 mt-md-0 ml-md-2"
          buttonStyle="border"
          @click="clickAddVeeam"
        >
          <div class="d-flex d-md-none">Add</div>
          <div class="d-none d-md-flex">Add Veeam</div>
        </atom-button>
      </div>
      <div class="filter-container card-padding pt-0 pb-3">
        <div class="row mt-0">
          <div
            class="col-12 col-md-4 mb-1 mb-md-0 d-flex justify-content-between"
          >
            <atom-input
              v-model="filterList.name"
              title="Server"
              placeholder="Server"
            ></atom-input>
          </div>
          <div
            class="col-12 col-md-5 mb-1 mb-md-0 d-flex justify-content-between"
          >
            <atom-input
              v-model="filterList.ip"
              title="IP Address"
              placeholder="IP Address"
            ></atom-input>
            <div class="d-flex align-items-end">
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                class="search__button ml-2"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <b-table
            sticky-header
            responsive
            :items="items"
            :fields="hasUpdatePermission ? fields : fields.filter(field => field.key !== 'deleteIcon')"
            :hover="true"
            @row-clicked="selectRow"
          >
            <template #cell(name)="data">
              <div>{{ data.value }}</div></template
            >
            <template #cell(ip)="data">
              <div>{{ data.value }}</div></template
            >
            <template #cell(description)="data">
              <div>{{ data.value }}</div></template
            ><template #cell(deleteIcon)="data">
              <atom-button
                buttonId="button-delete"
                iconLeft="Trash2Icon"
                buttonStyle="flat"
                buttonColor="secondary"
                :isDisable="false"
                @click="clickDeleteVeeam(data)"
              ></atom-button> </template
          ></b-table>
        </div>
      </div>
      <div class="row card-padding">
        <div class="col-6">Showing {{ items.length }} entries</div>
        <div class="col-6 d-flex justify-content-end">
          <b-pagination
            v-model="filterList.currentPage"
            :total-rows="filterList.totalCount"
            :per-page="perPage"
            size="sm"
            class="my-0"
          ></b-pagination>
        </div>
      </div>
    </b-card>
    <section name="add-veeam">
      <molecule-modal-dialog
        modalId="add-veeam"
        :isTextCenter="true"
        buttonTextLeft="Add Veeam"
        textTitle="Add Veeam"
        :isSlotBody="true"
        :isCloseOnBackDrop="false"
        :isDisableButtonLeft="isErrorValidate"
        @clickButtonLeft="clickConfirmAddVeeam"
        ><template #body>
          <div class="row mt-0">
            <div class="col-12 mt-2">
              <atom-input
                v-model="veeam.name"
                title="Server Name"
                placeholder="Server Name"
                :isAsterisk="true"
                :isError="isErrorServer"
                errorMessage="Server Name is required"
              ></atom-input>
            </div>
            <div class="col-12 col-md-8 mt-2">
              <atom-input
                v-model="veeam.ip"
                title="IP Address"
                placeholder="IP Address"
                :isAsterisk="true"
                :isError="isErrorIp"
                :errorMessage="errorMessageForIp"
              ></atom-input>
            </div>
            <div class="col-12 col-md-4 mt-2 pl-md-0">
              <atom-input
                v-model="veeam.port"
                title="Port"
                placeholder="Port"
                :isAsterisk="true"
                :isError="isErrorPort"
                :errorMessage="errorMessageForPort"
              ></atom-input>
            </div>
            <div class="col-12 mt-2">
              <atom-input
                v-model="veeam.username"
                title="Username"
                placeholder="Username"
                :isAsterisk="true"
                :isError="isErrorUsername"
                errorMessage="Username is required"
              ></atom-input>
            </div>
            <div class="col-12 mt-2">
              <atom-input
                v-model="veeam.password"
                title="Password"
                placeholder="Password"
                :isAsterisk="true"
                :isError="isErrorPassword"
                type="password"
                errorMessage="Password is required"
              ></atom-input>
            </div>
            <div class="col-12 mt-2">
              <atom-text-area
                v-model="veeam.description"
                title="Description"
                placeholder="Description"
                :rows="3"
                :isAsterisk="true"
                :isError="isErrorDescription"
                errorMessage="Description is required"
              ></atom-text-area>
            </div></div></template
      ></molecule-modal-dialog>
    </section>

    <section name="edit-veeam">
      <molecule-modal-dialog
        modalId="edit-veeam"
        :isTextCenter="true"
        buttonTextLeft="Save Changes"
        textTitle="Veeam Detial"
        :isSlotBody="true"
        :isCloseOnBackDrop="false"
        :isDisableButtonLeft="isErrorEditValidate"
        :isButtonLeft="hasUpdatePermission"
        :isButtonRight="hasUpdatePermission"
        @clickButtonLeft="clickConfirmEditVeeam"
        ><template #body>
          <div class="row mt-0">
            <div class="col-12 mt-2">
              <atom-input
                v-model="veeam.name"
                title="Server Name"
                placeholder="Server Name"
                :isAsterisk="true"
                :isError="isErrorServer"
                errorMessage="Server Name is required"
                :isDisable="!hasUpdatePermission"
              ></atom-input>
            </div>
            <div class="col-12 col-md-8 mt-2">
              <atom-input
                v-model="veeam.ip"
                title="IP Address"
                placeholder="IP Address"
                :isAsterisk="true"
                :isError="isErrorIp"
                :errorMessage="errorMessageForIp"
                :isDisable="!hasUpdatePermission"
              ></atom-input>
            </div>
            <div class="col-12 col-md-4 mt-2 pl-md-0">
              <atom-input
                v-model="veeam.port"
                title="Port"
                placeholder="Port"
                :isAsterisk="true"
                :isError="isErrorPort"
                :errorMessage="errorMessageForPort"
                :isDisable="!hasUpdatePermission"
              ></atom-input>
            </div>
            <div class="col-12 mt-2">
              <atom-input
                v-model="veeam.username"
                title="Username"
                placeholder="Username"
                :isAsterisk="true"
                :isError="isErrorUsername"
                errorMessage="Username is required"
                :isDisable="!hasUpdatePermission"
              ></atom-input>
            </div>
            <div class="col-12 mt-2">
              <atom-input
                v-model="veeam.password"
                title="Password"
                placeholder="Password"
                type="password"
                :isDisable="!hasUpdatePermission"
              ></atom-input>
            </div>
            <div class="col-12 mt-2">
              <atom-text-area
                v-model="veeam.description"
                title="Description"
                placeholder="Description"
                :isAsterisk="true"
                :rows="3"
                :isError="isErrorDescription"
                errorMessage="Description is required"
                :isDisable="!hasUpdatePermission"
              ></atom-text-area>
            </div></div></template
      ></molecule-modal-dialog>
    </section>

    <section name="delete-veeam">
      <molecule-modal-dialog
        modalId="delete-veeam"
        :isTextCenter="true"
        icon="AlertCircleIcon"
        textTitle="Do you want to delete?"
        :textSubtitle="deleteMessage"
        buttonTextLeft="Delete"
        buttonColorLeft="danger"
        :isDisableButtonLeft="isDisabledButtonConfirmDelete"
        :isSlotBody="true"
        @clickButtonLeft="confirmDelete"
        ><template #body
          ><div>
            <atom-input
              placeholder="delete"
              title="Please type delete to confirm"
              v-model="textConfirmDelete"
            ></atom-input></div></template
      ></molecule-modal-dialog>
    </section>
  </div>
</template>

<script>
import { BCard, BTable, BPagination, BBadge } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixinsValidator from "@/mixins/mixinsValidator"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "VeeamManagement",
  components: {
    BCard,
    BTable,
    BPagination,
    BBadge,
    AtomButton,
    AtomInput,
    AtomTextArea,
    MoleculeModalDialog,
  },
  props: {
    filterList: {
      required: true,
      type: Object,
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  mixins: [mixinsValidator, mixinsUser],
  data() {
    return {
      isValidateTrigger: false,
      perPage: 10,
      veeam: {
        name: "",
        ip: "",
        port: 9419,
        username: "",
        password: "",
        description: "",
      },
      deleteMessage: "",
      textConfirmDelete: "",
    }
  },
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.BMM.VEEAM_WRITE)
    },

    isErrorServer() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.veeam.name)
        : false
    },
    isErrorIp() {
      return this.isValidateTrigger ? this.isInvalidIpV4(this.veeam.ip) : false
    },
    isErrorPort() {
      return this.isValidateTrigger ? this.isNotNumeric(this.veeam.port) : false
    },
    isErrorUsername() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.veeam.username)
        : false
    },
    isErrorPassword() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.veeam.password)
        : false
    },
    isErrorDescription() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.veeam.description)
        : false
    },
    isErrorValidate() {
      return (
        this.isErrorServer ||
        this.isErrorIp ||
        this.isErrorPort ||
        this.isErrorUsername ||
        this.isErrorPassword ||
        this.isErrorDescription
      )
    },
    isErrorEditValidate() {
      return (
        this.isErrorServer ||
        this.isErrorIp ||
        this.isErrorPort ||
        this.isErrorUsername ||
        this.isErrorDescription
      )
    },
    isDisabledButtonConfirmDelete() {
      return this.textConfirmDelete.toLowerCase() !== "delete"
    },
    errorMessageForPort() {
      if (this.veeam.port === "") return "Port is required"
      else {
        return "Port should be a number"
      }
    },
    errorMessageForIp() {
      if (this.veeam.ip === "") return "Ip is required"
      else {
        return "Invalid IP Address"
      }
    },
  },
  watch: {
    "filterList.currentPage": {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit("onUpdateCurrentPage", this.filterList)
        }
      },
    },
  },
  methods: {
    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },
    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },
    selectRow(row) {
      this.veeam.id = row.id
      this.veeam.name = row.name
      this.veeam.ip = row.ip
      this.veeam.port = row.port
      this.veeam.username = row.username
      this.veeam.password = ""
      this.veeam.description = row.description
      this.openModal("edit-veeam")
    },
    clickAddVeeam() {
      this.clearVeeam()
      this.openModal("add-veeam")
    },
    clickConfirmAddVeeam() {
      this.isValidateTrigger = true
      if (!this.isErrorValidate) {
        const addVeeam = {
          veeamName: this.veeam.name,
          veeamProtocol: "https",
          veeamAddress: this.veeam.ip,
          veeamPort: this.veeam.port,
          veeamDescription: this.veeam.description,
          veeamUsername: this.veeam.username,
          veeamPassword: this.veeam.password,
        }
        this.$emit("addVeeam", addVeeam)
        this.closeModal()
      }
    },
    clickConfirmEditVeeam() {
      this.isValidateTrigger = true
      if (!this.isErrorEditValidate) {
        const veeamId = this.veeam.id
        const editVeeam = {
          veeamName: this.veeam.name,
          veeamProtocol: "https",
          veeamAddress: this.veeam.ip,
          veeamPort: this.veeam.port,
          veeamDescription: this.veeam.description,
          veeamUsername: this.veeam.username,
          veeamPassword: this.veeam.password,
        }
        this.$emit("editVeeam", veeamId, editVeeam)
        this.closeModal()
      }
    },
    clickDeleteVeeam(row) {
      this.deleteMessage = "Veeam server at: " + row.item.ip
      this.veeam.id = row.item.id
      this.openModal("delete-veeam")
    },
    confirmDelete() {
      this.$emit("deleteVeeam", this.veeam.id)
      this.closeModal()
      this.clearVeeam()
    },
    openModal(id) {
      if (this.modalId) this.closeModal()
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
      this.isValidateTrigger = false
    },
    clearVeeam() {
      this.veeam.name = ""
      this.veeam.ip = ""
      this.veeam.port = 9419
      this.veeam.username = ""
      this.veeam.password = ""
      this.veeam.description = ""
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-veeam_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-padding {
  padding: 1.5rem;
}
.card-body {
  padding: 0;
}
.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}
.filter-container {
  border-bottom: 1px solid #e9ecef;
}
.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:not(.disabled-button):hover {
    cursor: pointer;
    color: #7367f0;
  }
}
</style>
